<menu class="menu d-flex">
  <li *ngFor="let item of items" [routerLinkActiveOptions]="{ exact: true }" class="menu__item" routerLinkActive="active">
    <span class="menu__icon"></span>
    <a [routerLink]="item.route" class="menu__link"> {{ item.label | translate }} </a>
  </li>
</menu>
